import {XauditModel} from '../../../models/xaudit.model';
import {PatientCaseEndoRecallAutofillDetailModel} from './patient-case-endo-recall-autofill-detail.model';

export class PatientCaseEndoRecallAutofillModel extends XauditModel{
  AutofillID: string;
  AutofillName: string;

  cfgPatientCaseEndoRecallAutofillDetails: PatientCaseEndoRecallAutofillDetailModel[] = [];
}
